var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._g(_vm._b({tag:"component",attrs:{"id":_vm.id}},'component',_vm.props,false),_vm.events))
}
var staticRenderFns = []

export { render, staticRenderFns }